import { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { JCProjectedCost } from '@/src/app/Interfaces/Accounting/JobsContracts.interface';

type ProjectedDescriptionCellProps = {
  row: JCProjectedCost;
  onChange: (description?: string) => void;
  showError?: boolean;
};

const ProjectedDescriptionCell = ({
  row,
  onChange,
  showError,
}: ProjectedDescriptionCellProps) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(row.Description ?? '');
  const hasError = showError && !row.Description;

  useEffect(() => {
    setValue(row.Description ?? '');
  }, [row.Description]);

  if (!editing && !hasError) {
    return (
      <div
        className={
          row.Description
            ? 'scroll-text cursor-pointer totalColor'
            : 'cursor-pointer totalColor w-full flex justify-content-center'
        }
        onClick={() => setEditing(true)}
      >
        {row.Description || <i className="pi pi-pencil" />}
      </div>
    );
  }

  return (
    <InputText
      autoFocus={editing}
      className={`w-full ${hasError ? 'p-invalid' : ''}`}
      value={value}
      maxLength={60}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => {
        onChange(value);
        setEditing(false);
      }}
    />
  );
};

export default ProjectedDescriptionCell;
